import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { LESSON_SELECT_WAIT_TIME } from '../../live-class-revamp.module';
import { PrivateClassLesson } from '../private-class-lesson-dto';

@Component({
  selector: 'lp2-private-class-lesson-list',
  templateUrl: './private-class-lesson-list.component.html',
  styleUrls: ['./private-class-lesson-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PrivateClassLessonListComponent {
  public privateClassLessons: Array<PrivateClassLesson>;
  public totalLessons: number;
  public takenLessons: number;

  private enabled = true;

  @Output() select = new EventEmitter<number>();
  @Input() selectedLessonId: number;
  @Input() canBeSelected = false;
  @Input() set lessons(lessonsList: Array<PrivateClassLesson>) {
    if (lessonsList) {
      this.totalLessons = lessonsList.length;
      this.takenLessons = lessonsList.filter((lesson) => lesson.lessonTaken).length;

      this.privateClassLessons = lessonsList;
    }
  }

  public onSelected(lessonId: number) {
    if (!this.enabled) {
      return;
    }

    this.enabled = false;
    this.select.emit(lessonId);

    setTimeout(() => (this.enabled = true), LESSON_SELECT_WAIT_TIME);
  }
}



// WEBPACK FOOTER //
// ./ts/app/home/live-class-revamp/private-class-banner/private-class-lesson-list/private-class-lesson-list.component.ts